import { BaseNumberIdDataDto } from '../../../classes/common/response/base-number-id-data.dto';
export class VendorForChartDto extends BaseNumberIdDataDto {
    constructor(initializer) {
        super(initializer);
        this.name = initializer.name;
    }
}
